import {
  Paper,
  Grid,
  Box,
  Button,
  TextField,
  CircularProgress
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import React, { useState } from 'react'
import { WorkOrderBlogCreateDto } from '../../interfaces/WorkOrder/WorkOrderBlog'
import axios from 'axios'
import { ApiConfig } from '../../config/api'
import { useApi } from '../../hooks/useApi'
import { Status } from '../../hooks/useFetchState'

interface WorkOrderBlogFormProps {
  workOrderId: number
  getWorkOrderBlogs: () => void
}

const postWorkOrderBlog = (dto: WorkOrderBlogCreateDto) => {
  const url = new URL(`${ApiConfig.WorkOrderBlog}`)
  return axios.post(url.toString(), dto)
}

export const WorkOrderBlogForm: React.FC<WorkOrderBlogFormProps> = ({
  workOrderId,
  getWorkOrderBlogs
}) => {
  const { state, callApi } = useApi()

  const [comments, setComments] = useState('')

  const classes = useStyles()

  const requestCreateWorkOrderBlog = () => {
    callApi(
      postWorkOrderBlog({
        workOrderId,
        comments: `Observación: ${comments}`
      })
    )
      .then(() => {
        getWorkOrderBlogs()
        setComments('')
      })
      .catch((error) => console.error(error))
  }

  return (
    <Paper
      variant='outlined'
      sx={{
        p: 2,
        width: '100%',
        borderRadius: 2,
        borderColor: 'divider',
        boxShadow: 'none'
      }}
    >
      <Grid container spacing={2} alignItems='stretch'>
        <Grid item xs={12} md={8}>
          <TextField
            disabled={state.status === Status.Loading}
            rows={4}
            minRows={4}
            maxRows={4}
            variant='outlined'
            multiline
            fullWidth
            placeholder='Observaciones'
            value={comments}
            onChange={(e) => setComments(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Box
            component='span'
            m={1}
            className={`${classes.centerBox} ${classes.box}`}
            sx={{ m: 0, width: '100%' }}
          >
            <Button
              disabled={
                !comments ||
                comments.trim().length === 0 ||
                state.status === Status.Loading
              }
              variant='contained'
              color='primary'
              onClick={requestCreateWorkOrderBlog}
              fullWidth
              endIcon={
                state.status === Status.Loading && (
                  <CircularProgress size={10} />
                )
              }
            >
              Ingresar Observación
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  )
}

const useStyles = makeStyles({
  box: {
    height: '100%',
    minHeight: 112,
    display: 'flex'
  },
  centerBox: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  }
})
